<h1 class="title">
  Ajoutez une ou des personne(s) gestionnaire(s) de votre compte
</h1>
<h5 class="title-text-muted text-muted fs-16">
  Saisissez les coordonnées de la ou des personne(s) gestionnaire(s). Vous
  pouvez rajouter de nouvelles personnes ultérieurement dans vos paramètres.
</h5>
<div [formGroup]="finalStepFormGroup">
  <div formArrayName="persons">
    @for (item of contacts.controls; track item; let i = $index) {
    <div [formGroupName]="i">
      <div class="border border--1 rounded my-2 finalStepForm">
        <div
          class="border-bottom border-1 p-3 d-flex justify-content-between align-items-center"
        >
          <mat-label class="card-title"
            >Personne gestionnaire du compte N˚{{ i + 1 }}
            <span class="text-secondary"> </span>
          </mat-label>
          <div class="d-flex align-items-center">
            <svg-icon
              class="cursor-pointer"
              (click)="deleteNewContact(i)"
              src="/assets/icons/trash-red.svg"
            ></svg-icon>
          </div>
        </div>
        <div class="px-4 py-2">
          <div class="row my-3" style="padding: 0 12px">
            <!-- <app-custom-input [label]="'Nom du site'" [parentGroupName]="'{{$index}}'"  controlName="siteName"  [required]="true" ></app-custom-input> -->
            <mat-label>Email <span class="required">*</span></mat-label>
            <input type="text" [formControlName]="'mail'" />
          </div>

          <div class="row align-items-start">
            <div class="col-2">
              <!-- <app-custom-input [label]="'Pays'" [parentGroupName]="'{{$index}}'"  controlName="pays"  [required]="true" ></app-custom-input> -->
              <mat-label>Civilité <span class="required">*</span></mat-label>

              <mat-form-field class="dropdownClass" appearance="outline">
                <mat-select [formControlName]="'civility'">
                  @for (item of civilityOptions; track item) {
                  <mat-option [value]="item.value">{{ item.label }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <!--                <div class="invalid-feedback"-->
              <!--                     *ngIf="finalStepFormGroup.get('finalStepForm')?.invalid  && finalStepFormGroup.get('finalStepForm')?.touched">-->
              <!--                  {{'Title is ' + finalStepFormGroup.get('finalStepForm')?.errors}}-->
              <!--                </div>-->
            </div>
            <div class="col-4">
              <mat-label>Nom <span class="required">*</span></mat-label>
              <input
                type="text"
                style="width: 200px"
                [formControlName]="'firstName'"
              />
            </div>
            <div class="col-5">
              <mat-label>Prénom <span class="required">*</span></mat-label>
              <input
                type="text"
                class="ml-px-16 w-px-250"
                [formControlName]="'lastName'"
              />
            </div>
          </div>
          <div class="row">
            <div class="d-flex align-items-start">
              <app-custom-dragdrop-image
                text1=""
                innerClass="rounded border border-1 p-4 me-2"
                [singleImage]="true"
                text2=""
                width="146"
                height="146"
                [smallInput]="true"
                [url]="[item.get('photo1')?.value]"
                text3="Ajouter une photo de profil"
                icon="/assets/icons/camera.svg"
                (sendImage)="getImage($event, i)"
                [isDeletble]="true"
              >
              </app-custom-dragdrop-image>

              <div class="row">
                <div>
                  <mat-label
                    >Téléphone <span class="required">*</span></mat-label
                  >
                  <ngx-intl-tel-input
                    [cssClass]="'custom'"
                    [preferredCountries]="[
                      CountryISO.France,
                      CountryISO.France
                    ]"
                    [enableAutoCountrySelect]="false"
                    [enablePlaceholder]="true"
                    [searchCountryFlag]="true"
                    [searchCountryField]="[
                      SearchCountryField.Iso2,
                      SearchCountryField.Name
                    ]"
                    [selectFirstCountry]="false"
                    [selectedCountryISO]="CountryISO.France"
                     [maxLength]="phoneMaxLength"
                    [phoneValidation]="true"
                    [inputId]="'my-input-id'"
                    formControlName="numTel"
                    [(ngModel)]="phoneNumber"
                    (ngModelChange)="onInputChange($event)" 
                  ></ngx-intl-tel-input>
                </div>
                <div
                  *ngIf="
                    item.get('numTel')?.touched && item.get('numTel')?.invalid
                  "
                  class="required"
                >
                  Veuillez saisir un numéro valide.
                </div>
                <div class="d-flex flex-column my-4">
                  <mat-label
                    >Fonction <span class="required">*</span></mat-label
                  >
                  <input type="text" class="" [formControlName]="'fonction'" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    }
  </div>
</div>
<div
  class="d-flex justify-content-between align-items-center rounded border-1 border p-2 my-2"
>
  <span class="card-title">Ajouter une personne gestionnaire du compte</span>
  <app-button
    color="primary"
    [srcIcon]="'assets/icons/plus-circle-primary.svg'"
    (click)="addNewContact()"
    [stroked]="true"
    text="Ajouter"
  ></app-button>
</div>
<div class="row my-2">
  <app-button
    color="primary"
    text="Finaliser"
    [disabled]="loading"
    (click)="onSubmit.emit()"
    class="mx-auto text-center"
    [innerClass]="'p-3 w-100'"
  ></app-button>
</div>
